/* Pixlico CDL Prep — scripts communs (aucune dépendance externe, aucun secret).
   - ?lang=es|en dans les liens de pub -> URL de langue Shopify (/es/...)
   - barre d'appel collante (mobile)
   - lecture à voix haute (synthèse vocale du navigateur, anglais US)
*/
(function () {
  'use strict';

  /* ---------- 1. Langue par lien de pub ---------- */
  try {
    var params = new URLSearchParams(location.search);
    var want = params.get('lang');
    var cur = (document.documentElement.lang || 'en').slice(0, 2);
    if ((want === 'es' || want === 'en') && want !== cur) {
      params.delete('lang');
      // Chemin relatif uniquement : un seul « / » au début, jamais « // » ni schéma (pas de redirection ouverte, audit H2)
      var path = '/' + location.pathname.replace(/^[\/\\]+/, '').replace(/^es(\/|$)/, '');
      path = '/' + path.replace(/^[\/\\]+/, '');
      if (want === 'es') path = '/es' + (path === '/' ? '' : path);
      if (!/^\/(?![\/\\])/.test(path)) path = '/';
      var qs = params.toString();
      location.replace(location.origin + path + (qs ? '?' + qs : '') + location.hash);
      return;
    }
  } catch (e) {}

  /* ---------- 2. Voix ---------- */
  var Voice = {
    ok: 'speechSynthesis' in window,
    voice: null,
    pick: function () {
      if (!this.ok) return;
      var vs = window.speechSynthesis.getVoices();
      this.voice =
        vs.filter(function (v) { return /en[-_]US/i.test(v.lang) && /Samantha|Google US|Aria|Jenny|Natural/i.test(v.name); })[0] ||
        vs.filter(function (v) { return /en[-_]US/i.test(v.lang); })[0] ||
        vs.filter(function (v) { return /^en/i.test(v.lang); })[0] || null;
    },
    speak: function (text, rate, onend) {
      if (!this.ok) return false;
      window.speechSynthesis.cancel();
      if (!this.voice) this.pick();
      var u = new SpeechSynthesisUtterance(text);
      u.lang = 'en-US';
      u.rate = rate || 0.92;
      if (this.voice) u.voice = this.voice;
      u.onend = u.onerror = function () { if (onend) onend(); };
      window.speechSynthesis.speak(u);
      return true;
    },
    stop: function () { if (this.ok) window.speechSynthesis.cancel(); }
  };
  if (Voice.ok) { Voice.pick(); window.speechSynthesis.onvoiceschanged = function () { Voice.pick(); }; }
  window.RbVoice = Voice;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- 3. Barre collante : visible quand le bouton du héros sort de l'écran ---------- */
    var sticky = document.querySelector('[data-rb-sticky]');
    var anchors = document.querySelectorAll('[data-rb-sticky-anchor]');
    if (sticky && anchors.length && 'IntersectionObserver' in window) {
      var seen = new Map();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
        var show = true;
        seen.forEach(function (v) { if (v) show = false; });
        sticky.classList.toggle('rb-show', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('a').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
      });
      anchors.forEach(function (a) { io.observe(a); });
    }

    /* ---------- Lien « Your privacy choices » : ouvre les préférences de la bannière native Shopify ---------- */
    document.querySelectorAll('[data-rb-privacy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          e.preventDefault();
          window.privacyBanner.showPreferences();
        }
      });
    });

    /* ---------- 4. Boutons « écouter » simples : <button data-rb-speak="texte" data-rate="0.65"> ---------- */
    document.querySelectorAll('[data-rb-speak]').forEach(function (b) {
      b.addEventListener('click', function () {
        var box = b.closest('[data-rb-speak-box]') || b;
        if (box.classList.contains('rb-speaking')) { Voice.stop(); box.classList.remove('rb-speaking'); b.setAttribute('aria-pressed', 'false'); return; }
        var started = Voice.speak(b.getAttribute('data-rb-speak'), parseFloat(b.getAttribute('data-rate')) || 0.92, function () {
          box.classList.remove('rb-speaking'); b.setAttribute('aria-pressed', 'false');
        });
        if (!started) { var msg = box.querySelector('[data-rb-no-voice]'); if (msg) msg.hidden = false; return; }
        box.classList.add('rb-speaking'); b.setAttribute('aria-pressed', 'true');
      });
    });
  });
})();
